import defaultQuery from './default.js'
import getId from './get-id.js'
import recentQuery from './recent.js'
import relatedContent from './related-content.js'
import sharedQuery from './shared.js'
import templatesQuery from './templates.js'
import typeQuery from './type-query.js'
import aiTypeQuery from './ai-type-query.js'
import autolinkQuery from './autolink.js'

/**
 * @see https://www.elastic.co/guide/en/elasticsearch/reference/7.x/query-dsl.html
 */

/**
 * @note The queries are subjected to "authorization filter" server-side, so not all ES queries will be valid.
 */
export const allQueries = {
  default: defaultQuery,
  relatedContent,
  getId,
  type: typeQuery,
  recent: recentQuery,
  shared: sharedQuery,
  templates: templatesQuery,
  autolink: autolinkQuery,
  aiType: aiTypeQuery,
}
export type QueryType = keyof typeof allQueries
